// extracted by mini-css-extract-plugin
export default {"inactive":"notFound_inactive__byfNX","notFound":"notFound_notFound__xa2-p","notFound404":"notFound_notFound404__PNz1e"};